import { SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import useOptionsChatFloating from 'v2/resources/hooks/useOptionsChatFloating';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';

const useChatFloating = () => {
  const { isMobile, isTablet } = useWindowSizes();
  const { options, prompt, data, handleChangeSetValue } =
    useOptionsChatFloating();
  const [isOpenBox, setIsOpenBox] = useState<boolean>(false);

  const handleChangeBox = () => {
    setIsOpenBox((prevState) => !prevState);
  };

  const handleOnChange = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;

    handleChangeSetValue(value as string);
  };

  const distance = isMobile || isTablet ? 10 : 30;
  return {
    isOpenBox,
    options,
    promptParam: prompt,
    dataParam: data,
    distance,
    handleChangeBox,
    handleOnChange,
  };
};

export default useChatFloating;
